import horoscopesReducer from "./reducers";
export { default as horoscopesTypes } from "./types";
export { default as horoscopesOperations } from "./operations";
export default horoscopesReducer;
